import * as React from "react";
import { useState } from "react";
import { Flex, Text, TextField, Button } from "@radix-ui/themes";
import { STRINGS } from "../../../constants/strings";

interface LoginFormProps {
  onLogin: (email: string, password: string) => void;
  loading: boolean;
}

export const LoginForm: React.FC<LoginFormProps> = ({ onLogin, loading }) => {
  const [email, setEmail] = useState("");
  const [password, setPassword] = useState("");

  const handleSubmit = (e: React.FormEvent) => {
    e.preventDefault();
    onLogin(email, password);
  };

  return (
    <form
      onSubmit={handleSubmit}
      style={{ display: "flex", flexDirection: "column", gap: "16px", width: "100%" }}
    >
      <Flex direction="column" gap="1">
        <Text as="label" size="2" weight="medium">
          {STRINGS.AUTH.EMAIL_LABEL}
        </Text>
        <TextField.Root
          type="email"
          placeholder={STRINGS.AUTH.EMAIL_PLACEHOLDER}
          value={email}
          onChange={(e) => setEmail(e.target.value)}
          required
        />
      </Flex>

      <Flex direction="column" gap="1">
        <Text as="label" size="2" weight="medium">
          {STRINGS.AUTH.PASSWORD_LABEL}
        </Text>
        <TextField.Root
          type="password"
          placeholder={STRINGS.AUTH.PASSWORD_PLACEHOLDER}
          value={password}
          onChange={(e) => setPassword(e.target.value)}
          required
        />
      </Flex>

      <Button
        size="3"
        type="submit"
        loading={loading}
        disabled={loading}
        style={{ marginTop: "8px" }}
      >
        {loading ? STRINGS.AUTH.SIGNING_IN_BUTTON : STRINGS.AUTH.SIGN_IN_BUTTON}
      </Button>
    </form>
  );
};
